import type { PostFaq as PostFaqItem } from "@/data/postFaqs";

interface PostFaqProps {
  faqs?: PostFaqItem[] | undefined;
}

/**
 * Visible FAQ block for blog posts. Question and answer text are always in the
 * server rendered DOM (no conditional rendering) so the FAQPage JSON-LD emitted
 * in src/routes/blog.$slug.tsx has matching on-page content.
 */
const PostFaq = ({ faqs }: PostFaqProps) => {
  if (!faqs?.length) return null;

  return (
    <section className="mt-16 border-t border-border pt-12" aria-labelledby="post-faq-heading">
      <h2 id="post-faq-heading" className="mb-6 text-2xl font-bold text-foreground">
        Frequently asked questions
      </h2>
      <div className="divide-y divide-border rounded-xl border border-border bg-card">
        {faqs.map((faq, i) => (
          <div key={i} className="p-5 md:p-6">
            <h3 className="mb-2 text-base font-semibold text-card-foreground md:text-lg">
              {faq.q}
            </h3>
            <p className="text-sm leading-relaxed text-muted-foreground md:text-base">
              {faq.a}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PostFaq;
